export default "__VITE_ASSET__04a57695__"